<template>
  <v-container
    id="cadastro-usuario-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div
      v-if="!paginaEnable"
    >
      <h1 style="display: none">
        Você não tem permissão para acessar essa pagina.
      </h1>
    </div>
    <div
      v-else
    >
      <div v-if="!user">
        <v-row>
          <v-col
            cols="12"
            lg="12"
            class="px-1"
          >
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                lg="12"
                class="px-1"
              >
                <base-material-card
                  :color="corPrimaria"
                  :app-online="appOnline"
                  class="py-3 px-5"
                >
                  <template v-slot:heading>
                    <div
                      class="text-h3 font-bold-light"
                    >
                      Cadastro de Usuário
                    </div>
                  </template>
                </base-material-card>
                <v-divider class="mb-5" />
                <v-row>
                  <v-col
                    cols="12"
                    lg="12"
                    class="py-3 px-5"
                  >
                    <v-row class="text-center">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-row>
                          <v-col
                            cols="4"
                            md="4"
                          >
                            <tex-field-with-validation
                              :value="usuario.nome"
                              rules="required|regex:^([a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+)$"
                              type="text"
                              label="Nome..."
                              prepend-icon="mdi-account-box-outline"
                              @input="(value) => { usuario.nome = value }"
                            />
                          </v-col>
                          <v-col
                            cols="4"
                            md="4"
                          >
                            <tex-field-with-validation
                              :value="usuario.email"
                              rules="email"
                              required
                              type="email"
                              label="Email ..."
                              prepend-icon="mdi-email-fast"
                              @input="(value) => { usuario.email = value }"
                            />
                          </v-col>
                          <v-col
                            cols="4"
                            md="4"
                          >
                            <tex-field-with-validation
                              :value="usuario.password"
                              :rules="{ min: 4, message: 'Campo senha tem que ter no mínimo 4 caracteres' }"
                              required
                              type="password"
                              label="Senha"
                              prepend-icon="mdi-lock"
                              :append-icon="inputType ? 'mdi-eye' : 'mdi-eye-off'"
                              @input="(value) => { usuario.password = value }"
                              @click:append="inputType = !inputType"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col
                        cols="4"
                        lg="2"
                      >
                        <v-btn
                          v-if="usuario.nome && usuario.email && usuario.password"
                          id="logar"
                          small
                          class="v-btn--block"
                          :color="corPrimaria"
                          @click="salvar()"
                        >
                          Salvar
                        </v-btn>
                        <v-btn
                          v-else
                          id="logar"
                          small
                          disabled
                          class="v-btn--block"
                          :color="corPrimaria"
                          @click="salvar()"
                        >
                          Salvar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row><br><br>
      </div>
      <div v-else>
        <v-row>
          <v-col
            cols="12"
            lg="12"
            class="px-1"
          >
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                lg="12"
                class="px-1"
              >
                <base-material-card
                  :color="corPrimaria"
                  :app-online="appOnline"
                  class="py-3 px-5"
                >
                  <template v-slot:heading>
                    <div
                      class="text-h3 font-bold-light"
                    >
                      Cadastro de Usuário
                    </div>
                  </template>
                </base-material-card>
                <v-col
                  cols="2"
                  lg="1"
                >
                  <v-btn
                    id="logar"
                    small
                    class="v-btn--block"
                    :color="corPrimaria"
                    @click="resetFormulario()"
                  >
                    <v-icon>
                      mdi-plus
                    </v-icon>
                    Novo
                  </v-btn>
                </v-col>
                <v-divider class="mb-5" />
                <v-row>
                  <v-col
                    cols="12"
                    lg="12"
                    class="py-3 px-5"
                  >
                    <v-row class="text-center">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-row>
                          <v-col
                            cols="4"
                            md="4"
                          >
                            <tex-field-with-validation
                              :value="user.nome"
                              rules="required|regex:^([a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+)$"
                              type="text"
                              :disabled="userMaster"
                              label="Nome..."
                              prepend-icon="mdi-account-box-outline"
                              @input="(value) => { user.nome = value }"
                            />
                          </v-col>
                          <v-col
                            cols="4"
                            md="4"
                          >
                            <tex-field-with-validation
                              :value="user.username"
                              rules="email"
                              required
                              type="email"
                              label="Email ..."
                              :disabled="userMaster"
                              prepend-icon="mdi-email-fast"
                              @input="(value) => { user.username = value }"
                            />
                          </v-col>
                          <v-col
                            cols="2"
                            md="2"
                          >
                            <div
                              id="idStatus"
                            >
                              Status
                            </div>
                            <v-checkbox
                              id="checkUser"
                              v-model="user.ativo"
                              :disabled="userMaster"
                              :label="user.ativo ? 'Ativo' : 'Inativo'"
                            />
                          </v-col>
                          <v-col
                            cols="2"
                            md="2"
                          >
                            <v-btn
                              id="logarUsuario"
                              small
                              class="v-btn--block"
                              :color="corPrimaria"
                              :disabled="userMaster"
                              @click="atualizarUsuario()"
                            >
                              Atualizar
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            v-model="tab"
            background-color="#2863af"
            dark
          >
            <v-tab>Páginas</v-tab>
            <v-tab>Vendedores</v-tab>
          </v-tabs>
          <v-divider />
          <v-window v-model="tab">
            <v-window-item :value="0">
              <v-card
                flat
                class="pa-4"
              >
                <v-btn
                  id="btnShowPermissao"
                  class="text-left"
                  small
                  :color="corPrimaria"
                  :disabled="userMaster"
                  @click="showListaPaginas()"
                >
                  Permissões Páginas
                </v-btn>
                <div v-if="permissions">
                  <div style="overflow-x:auto;">
                    <div
                      id="idTable"
                      style="overflow-x: auto; max-width: 100%;"
                    >
                      <table
                        style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                        class="elevation-1"
                      >
                        <thead>
                          <tr>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Nome
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Modulo
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Url
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Permissão
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Atualizar
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in permissions"
                            :key="item.id"
                          >
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.nome }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.modulo }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: center;"
                            >
                              {{ item.url }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: center;"
                            >
                              {{ item.permissao }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: center;"
                            >
                              <v-icon
                                class="text-h2"
                                :color="corPrimaria"
                                @click="cadastrarPemissao(item), excluirPagina = true"
                              >
                                mdi-pencil
                              </v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else>
                  Não há permissões cadastradas para esse usuário
                </div>
              </v-card>
            </v-window-item>
            <v-window-item :value="1">
              <v-card
                flat
                class="pa-4"
              >
                <v-btn
                  id="btnShowPermissao"
                  class="text-left"
                  small
                  :color="corPrimaria"
                  :disabled="userMaster"
                  @click="showListaVendedores()"
                >
                  Visualização de Dados
                </v-btn>
                <div v-if="permissionsVendedores">
                  <div
                    id="idTable"
                    style="overflow-x: auto; max-width: 100%;"
                  >
                    <table
                      style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                      class="elevation-1"
                    >
                      <thead>
                        <tr>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Nome
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Remover
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in vendedoresExibicao"
                          :key="item.id"
                        >
                          <td
                            id="dadoMovimentacao"
                            style="text-align: left;"
                          >
                            {{ item.vendedor }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: center;"
                          >
                            <v-icon
                              class="text-h2"
                              :color="corError"
                              @click="RemoverVendedor(item)"
                            >
                              mdi-close
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else>
                  Permitido a exibição dos dados de todos os vendores
                </div>
              </v-card>
            </v-window-item>
          </v-window>
        </v-card>
      </div>
    </div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="700px"
        @keydown.esc="dialog.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog.visible = false, excluirPagina = true"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <h4>{{ dialog.message }}</h4>
          </v-card-text>
          <v-card-text class="pb-3 pt-6 text-center">
            <v-container>
              <v-row class="text-center">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-row>
                    <v-col
                      cols="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="pagina.modulo"
                        type="text"
                        label="Modulo..."
                        disabled
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="pagina.menuModulo"
                        type="text"
                        label="Nome do link ..."
                        disabled
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="pagina.url"
                        type="text"
                        label="Url do item"
                        disabled
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                    >
                      <v-select
                        v-if="!selected"
                        v-model="selectPermissao"
                        :items="type"
                        item-value="id"
                        item-text="nome"
                        label="Tipo de Permissão"
                        return-object
                      />
                      <v-select
                        v-else
                        v-model="selectPermissao"
                        :items="type"
                        item-value="id"
                        item-text="nome"
                        label="Tipo de Permissão"
                        return-object
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      v-if="excluirPagina"
                      cols="4"
                      lg="2"
                    >
                      <v-btn
                        id="logar"
                        small
                        class="v-btn--block"
                        :color="corError"
                        @click="excluirPermissao(pagina), dialog.visible = false, excluirPagina = true"
                      >
                        Excluir
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="4"
                      lg="2"
                    >
                      <v-btn
                        id="logar"
                        small
                        class="v-btn--block"
                        :color="corPrimaria"
                        @click="salvarPermissao(), dialog.visible = false, excluirPagina = true"
                      >
                        Salvar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        id="dialogFiltros"
        v-model="dialog2.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="950px"
        @keydown.esc="dialog2.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog2.visible = false"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <h2>{{ dialog2.message }}</h2>
          </v-card-text>
          <v-row class="text-center">
            <v-col
              cols="2"
            >
              <h3
                id="textoFiltro"
                class="text-center"
              >
                Filtros
              </h3>
            </v-col>
            <v-col
              id="filtroModulo"
              cols="5"
            >
              <v-select
                v-model="moduloSelect"
                :items="modulo"
                item-value="id"
                item-text="nome"
                label="Modulo"
                multiple
                return-object
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.nome }}, </span>
                  </v-chip>
                  <v-chip v-if="index === 1">
                    <span>{{ item.nome }}, </span>
                  </v-chip>
                  <v-chip v-if="index === 2">
                    <span>{{ item.nome }}, </span>
                  </v-chip>
                  <span
                    v-if="index === 3"
                    class="grey--text text-caption"
                  >
                    (+{{ moduloSelect.length - 3 }} outros)
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col
              id="filtroPagina"
              cols="5"
            >
              <tex-field-with-validation
                v-model="paginaSelect"
                label="Nome ..."
              />
              <v-icon
                id="iconSearch"
                :color="corPrimaria"
                @click="filterPaginas"
              >
                mdi-magnify
              </v-icon>
            </v-col>
          </v-row>
          <v-container>
            <v-row class="text-center">
              <v-col
                cols="12"
                md="12"
              >
                <div
                  id="idTable"
                  style="overflow-x: auto; max-width: 100%;"
                >
                  <table
                    style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                    class="elevation-1"
                  >
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Nome
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Modulo
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Url
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Adicionar Permissão
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in (enablefilter ? paginasFilter : paginas)"
                        :key="item.id"
                      >
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ item.nome }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ item.modulo }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: center;"
                        >
                          {{ item.url }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: center;"
                        >
                          <v-icon
                            class="text-h2"
                            :color="corPrimaria"
                            @click="cadastrarPemissao(item), excluirPagina = false"
                          >
                            mdi-plus-circle-outline
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        id="dialogFiltros"
        v-model="dialogVendedores.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="950px"
        @keydown.esc="dialogVendedores.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialogVendedores.visible = false"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <h2>{{ dialogVendedores.message }}</h2>
          </v-card-text>
          <v-container>
            <v-row class="text-center">
              <v-col
                cols="12"
                md="12"
              >
                <div
                  id="idTable"
                  style="overflow-x: auto; max-width: 100%;"
                >
                  <table
                    style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                    class="elevation-1"
                  >
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Nome
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Visualizar Dados
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in vendedores"
                        :key="item.id"
                      >
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ item.vendedor }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: center;"
                        >
                          <v-simple-checkbox
                            v-model="item.visualizarDados"
                            :ripple="false"
                            color="green"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-row justify="center">
            <v-col
              cols="4"
              lg="2"
            >
              <v-btn
                id="logar"
                small
                class="v-btn--block"
                :color="corPrimaria"
                @click="permitirVisualizarDados(), dialogVendedores.visible = false"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    >
      {{ snackbar.message }}
    </dashboard-core-snackbar>
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Usuario from '../../../../services/usuario'
  import Menu from '../../../../services/menu'

  export default {
    name: 'PageComercial',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      corError: '#D32F2F',
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      emailRules: [
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail é obrigatório',
      ],
      nomeRules: [
        v => /^[a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+$/.test(v) || 'Nome é obrigatório e não pode conter apenas espaços e caracteres especiais',
      ],
      usuario: {
        email: '',
        password: '',
        nome: '',
      },
      select: {},
      selectPermissao: [],
      selected: false,
      type: [
        { id: 1, text: 'ADMINISTRADOR', nome: 'Administrador' },
        { id: 2, text: 'USUARIO', nome: 'Usuário' },
        { id: 3, text: 'MASTER', nome: 'Master' },
      ],
      permissions: [],
      permissao: {
        modulo: '',
        menuModulo: '',
        url: '',
        moduloId: '',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      usuarios: [],
      headers: [
        { text: 'Nome', value: 'nome', width: '20%', class: 'black--text title' },
        { text: 'Modulo', value: 'modulo', width: '20%', align: 'center', class: 'black--text title' },
        { text: 'Url', value: 'url', width: '20%', align: 'center', class: 'black--text title' },
        { text: 'Permissão', value: 'permissao', width: '20%', align: 'center', class: 'black--text title' },
        { text: 'Atualizar', value: 'actions', width: '20%', align: 'center', class: 'black--text title' },
      ],
      headers2: [
        { text: 'Nome', value: 'nome', width: '25%', class: 'black--text title' },
        { text: 'Modulo', value: 'modulo', width: '25%', align: 'center', class: 'black--text title' },
        { text: 'Url', value: 'url', width: '25%', align: 'center', class: 'black--text title' },
        { text: 'Adicionar Permissão', value: 'adicionar', width: '25%', align: 'center', class: 'black--text title' },
      ],
      dialog: {
        visible: false,
        message: '',
      },
      dialog2: {
        visible: false,
        message: '',
      },
      dialogVendedores: {
        visible: false,
        message: '',
      },
      user: false,
      userGet: false,
      paginas: [],
      expanded: [],
      pagina: {
        id: '',
        modulo: '',
        menuModulo: '',
        moduloId: '',
        url: '',
        visible: '',
      },
      enabled: true,
      userMaster: false,
      excluirPagina: false,
      paginaEnable: false,
      inputType: false,
      modulo: [],
      moduloSelect: [],
      paginaFiltro: [],
      paginaSelect: '',
      paginasFilter: [],
      enablefilter: false,
      vendedores: [],
      vendedoresExibicao: [],
      dynamicPadding: '',
      permissionsVendedores: false,
      tab: 0,
    }),

    created () {
      this.$root.$on('enable-permissao', (paginaEnable) => {
        this.paginaEnable = paginaEnable
      })
    },

    mounted () {
      Menu.verificarPermissaoPaginaUsuario(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
        if (resposta.data.status) {
          this.paginaEnable = true
        } else {
          this.$router.push('/dashboard')
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        }
      })

      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        if (localStorage.userUsername) {
          // localStorage.removeItem('userId')
          // localStorage.removeItem('userUsername')

          this.showUser()
          this.showPermissions()
          this.showVendedoresExibicao()
        }
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        localStorage.removeItem('userUsername')
        localStorage.removeItem('userId')
        this.$router.push('/login')
      }
    },

    methods: {
      async showUser () {
        await Menu.showUser(localStorage.userId, localStorage.userUsername, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.user = resposta.data.usuario
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async showPaginas () {
        await Menu.showPaginas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.paginas = resposta.data.paginas

            this.paginaFiltro = resposta.data.pagina

            this.modulo = resposta.data.modulo
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Páginas não encontradas') {
            this.showSnackbar('error', 3000, 'Páginas não encontradas')
          }
        })
      },

      cadastrarPemissao (value) {
        this.pagina.modulo = value.modulo
        this.pagina.menuModulo = value.nome
        this.pagina.url = value.url
        this.pagina.id = value.paginaId
        this.pagina.visible = value.visible
        this.pagina.moduloId = value.moduloId

        if (value.permissao) {
          var i = 0

          for (i in this.type) {
            if (this.type[i].nome === value.permissao) {
              this.selectPermissao = this.type[i]
            }
          }
        }

        this.showDialog('Cadastrar Permissão')
      },

      async showPermissions () {
        await Menu.showPermissions(localStorage.userId, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.permissao) {
            this.permissions = resposta.data.permissao
          } else {
            this.permissions = false
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async showUsuarios () {
        await Menu.showUsuarios(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.usuarios) {
            this.usuarios = resposta.data.usuarios
          } else {
            this.usuarios = 0
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async salvarPermissao () {
        await Menu.salvarPermissao(this.pagina, localStorage.userId, localStorage.userUsername, this.selectPermissao, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.msg === 'Permissão atualizada com sucesso') {
            this.permissao.modulo = ''
            this.permissao.menuModulo = ''
            this.permissao.url = ''
            this.selectPermissao = ''
            this.showSnackbar('success', 3500, resposta.data.msg)

            this.showPermissions()
          } else if (resposta.data.msg === 'Permissão cadastrada com sucesso') {
            this.permissao.modulo = ''
            this.permissao.menuModulo = ''
            this.permissao.url = ''
            this.selectPermissao = ''

            this.showPermissions()
            this.showSnackbar('success', 3500, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.errors === 'Usuario não encontrado') {
            this.showSnackbar('error', 3000, e.data.errors)
          } else if (e.data.errors === 'Página não encontrada') {
            this.showSnackbar('error', 3000, e.data.errors)
          } else if (e.data.errors === 'Empresa não encontrada') {
            this.showSnackbar('error', 3000, e.data.errors)
          }
        })
      },

      async excluirPermissao (pagina) {
        await Menu.excluirPermissao(localStorage.userUsername, pagina, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.permissao.modulo = ''
            this.permissao.menuModulo = ''
            this.permissao.url = ''
            this.selectPermissao = ''
            this.showSnackbar('success', 3000, resposta.data.msg)
            this.showPermissions()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async salvar () {
        var padraoEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

        var padraoNome = /^[a-zA-Z0-9-_]+([a-zA-Z0-9-_ ])+$/

        var validaEmail = this.usuario.email.match(padraoEmail)

        var validaNome = this.usuario.nome.match(padraoNome)

        if (!validaNome || !this.usuario.nome) {
          alert('Nome é obrigatório ou está com formato inválido')
        } else if (!validaEmail || !this.usuario.email) {
          alert('Email é obrigatório ou está com formado inválido')
        } else if (this.usuario.username !== '' && this.usuario.email !== '' && this.usuario.password !== '') {
          await Usuario.saveUser(this.usuario, localStorage.tokencontrato, window.location.href).then(resposta => {
            if (!resposta.data.status) {
              this.showSnackbar('error', 5000, resposta.data.msg)
            } else if (resposta.data.status) {
              this.showSnackbar('success', 3000, resposta.data.msg)

              this.enabled = false
              this.user = resposta.data.usuario
              localStorage.setItem('userId', this.user.id)
              localStorage.setItem('userUsername', this.user.username)

              this.usuario.nome = ''
              this.usuario.email = ''
              this.usuario.password = ''
              this.select = ''
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        } else {
          alert('Campos Nome, Email e Senha são obrigatórios')
        }
      },

      async atualizarUsuario () {
        if (this.user.nome !== '' && this.user.username !== '') {
          Usuario.atualizarUsuario(this.user, localStorage.tokencontrato, window.location.href).then(resposta => {
            if (resposta.data.status) {
              this.showSnackbar('success', 3000, resposta.data.msg)
            } else if (resposta.data.msg === 'Email informado já está cadastrado em um outro usuário, favor verificar a Lista de Usuários') {
              this.showSnackbar('success', 3000, resposta.data.msg)
              alert('Clique para verificar a Lista de Usuários', this.$router.push('/usuarios/lista-usuarios'))
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'Usuário não encontrado') {
              this.showSnackbar('error', 3000, 'Usuário não encontrado')
            } else if (e.data.msg === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          })
        } else if (this.user.nome === '') {
          alert('Campos nome não pode ser vazio')
        } else if (this.user.username === '') {
          alert('Campos email não pode ser vazio')
        } else {
          alert('Campos Nome, Email não podem estar vazios')
        }
      },

      filterPaginas () {
        this.enablefilter = false

        if (this.paginaSelect.length > 0 && this.moduloSelect.length > 0) {
          this.enablefilter = true

          this.paginasFilter = this.paginas.filter(item =>
            this.moduloSelect.some(modulo => item.modulo === modulo.nome) &&
            this.paginaSelect.split(',').some(paginaParte => item.nome.toLowerCase().includes(paginaParte.toLowerCase())),
          )
        } else if (this.paginaSelect.length > 0) {
          this.enablefilter = true

          this.paginasFilter = this.paginas.filter(item =>
            this.paginaSelect.split(',').some(paginaParte => item.nome.toLowerCase().includes(paginaParte.toLowerCase())),
          )
        } else if (this.moduloSelect.length > 0) {
          this.enablefilter = true

          this.paginasFilter = this.paginas.filter(item =>
            this.moduloSelect.some(pagina => item.modulo === pagina.nome),
          )
        } else {
          this.paginasFilter = []
        }
      },

      resetFormulario () {
        this.user = false
        localStorage.removeItem('userUsername')
        localStorage.removeItem('userId')
      },

      showListaPaginas () {
        this.showPaginas()

        this.paginas = []

        this.showDialog2('Lista de páginas')
      },

      showModal () {
        this.showDialog('Cadastrar Permissão')
      },

      showModal2 (message, permissao) {
        this.permissao = permissao
        this.showDialog2(message, this.permissao)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },

      showDialog2 (message) {
        this.dialog2.visible = true
        this.dialog2.message = message
      },

      showListaVendedores () {
        this.showVendedores()

        this.vendedores = []

        this.showDialog3('Lista de Vendedores')
      },

      showDialog3 (message) {
        this.dialogVendedores.visible = true
        this.dialogVendedores.message = message
      },

      async showVendedores () {
        await Menu.showDadosVendedores(localStorage.tokencontrato, localStorage.userId).then(resposta => {
          if (resposta.data.status) {
            this.vendedores = resposta.data.vendedor

            this.permissionsVendedores = true
          } else if (resposta.data.msg === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async permitirVisualizarDados () {
        await Menu.showSalvarDadosRelacao(localStorage.tokencontrato, localStorage.userId, localStorage.userUsername, this.vendedores).then(resposta => {
          if (resposta.data.status) {
            this.vendedoresExibicao = this.vendedores
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            this.vendedoresExibicao.length > 0 ? this.permissionsVendedores = true : this.permissionsVendedores = false

            this.showSnackbar('success', 3000, 'Dados salvos com sucesso')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async showVendedoresExibicao () {
        await Menu.showDadosVendedores(localStorage.tokencontrato, localStorage.userId).then(resposta => {
          if (resposta.data.status) {
            this.vendedoresExibicao = resposta.data.vendedor
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            if (this.vendedoresExibicao.length > 0) {
              this.permissionsVendedores = true
            }
          } else if (resposta.data.msg === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async RemoverVendedor (vendedor) {
        await Menu.removerVendedorRelacao(localStorage.tokencontrato, localStorage.userId, localStorage.userUsername, vendedor).then(resposta => {
          if (resposta.data.status) {
            this.vendedoresExibicao = resposta.data.vendedor
              .filter(v => v.visualizarDados === true)
              .map(v => ({
                id: v.id,
                vendedor: v.vendedor,
              }))

            this.vendedoresExibicao.length > 0 ? this.permissionsVendedores = true : this.permissionsVendedores = false
          } else if (resposta.data.msg === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
        console.log(vendedor)
      },
    },
  }
</script>

<style scoped>
  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 410px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #ul_product
    list-style-type: none
    margin-left: -3rem

  #btnCadPermissao
    margin-left: 1.5rem

  #idStatus
    margin: -0.5rem auto
    text-align: left
    color: gray

  #logarUsuario
    margin: 1.5rem auto 0 -1rem

  #checkUser
    margin: -10rem auto

  #textoFiltro
    margin: 1.8rem 0 0 -4rem

  #iconSearch
    margin: -6rem 0 0 28rem

  #filtroModulo
    margin: 0 0 0 -5rem

  #filtroPagina
    margin: 0 0 0 -1rem

</style>
